<template>
  <div class="modal-wrapper">
    <div class="modal-close" @click="closeModal">
      <i class="fas fa-times"></i>
    </div>
    <div class="modal-container">
      <div class="modal-header">
        <p class="title title--1 title--white">
          {{ $t('filter.assign_expert') }}
        </p>
      </div>
      <table class="list modal-body">
        <tbody>
          <tr
            v-for="(expert, i) in experts"
            :key="i"
            class="list__line list__line--border-white list__line--flat"
            :class="{ 'list__line--active': isExpertSelected(expert) }"
          >
            <td>
              <button
                class="link link--clean link--full-width"
                @click.prevent="selectExpert(expert)"
              >
                {{
                  expertName({
                    firstName: expert.firstName,
                    lastName: expert.lastName,
                  })
                }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="modal-footer">
        <button class="button button--danger" @click="deleteExpertFilter">
          {{ $t('filter.remove_filter') }}
        </button>
        <button class="button button--cancel" @click="closeModal">
          {{ $t('cancel') }}
        </button>
        <button
          class="button button--valid"
          @click="expertFilter(estimations.expert)"
        >
          {{ $t('filter.add_expert_filter') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EstimationComponent, expertName } from '@/mixins';

export default {
  mixins: [expertName, EstimationComponent],

  props: {
    selectedExpert: {
      required: true,
    },
  },

  data() {
    return {
      internalSelectedExpert: this.selectedExpert,
    };
  },

  computed: {
    ...mapGetters('expert', ['experts']),
  },

  created() {
    if (this.experts.length === 0) {
      this.fetchExperts();
    }
  },

  methods: {
    ...mapActions('expert', ['fetchExperts']),

    selectExpert(expert) {
      this.internalSelectedExpert = expert;
    },

    expertFilter() {
      if (this.internalSelectedExpert !== undefined)
        this.$emit('filter', [this.internalSelectedExpert]);
      this.closeModal();
    },

    deleteExpertFilter() {
      this.$emit('deleteExpertFilter');
      this.closeModal();
    },

    closeModal() {
      this.$emit('closeModal');
    },

    isExpertSelected(expert) {
      return (
        this.internalSelectedExpert && expert.id === this.internalSelectedExpert.id
      );
    },
  },
};
</script>
